import { PastSavingsGoalLine } from "./PastSavingsGoalLine";
import { newestOf } from "./savingsGoalSeries";
import { PastSavingsGoalSeriesProps } from "./types";
import { CardTop, GoalName, PastItem, PastLines } from "./styles";
import Button, { ButtonTypes } from "../../../components/Button";

export const PastSavingsGoalSeries = ({
  series,
  canRollForward,
  isRollForwardDisabled,
  onRollForward,
  onDelete,
}: PastSavingsGoalSeriesProps) => {
  const newest = newestOf(series);

  return (
    <PastItem data-testid="past-savings-series">
      <CardTop>
        <GoalName>{newest.name}</GoalName>
        {canRollForward && (
          <Button
            type={ButtonTypes.link}
            size="small"
            tone="muted"
            disabled={isRollForwardDisabled}
            onClick={() => onRollForward(newest)}
          >
            Roll forward
          </Button>
        )}
      </CardTop>

      <PastLines>
        {series.goals.map((goal) => (
          <PastSavingsGoalLine key={goal.id} goal={goal} onDelete={onDelete} />
        ))}
      </PastLines>
    </PastItem>
  );
};
